/**
 * La marque résolue, lisible depuis n'importe quel écran.
 *
 * Volontairement sans contexte React ni store global : la marque est chargée une
 * fois, au démarrage, et ne change plus pendant la session. Un `useSyncExternal
 * Store` sur un objet de module suffit, et évite d'imposer un fournisseur autour
 * de l'arbre — donc d'obliger chaque écran à savoir qu'une marque existe.
 */
import { useSyncExternalStore } from 'react';
import {
  ContexteDeMarque,
  MARQUE_MAISON,
  abonnerALaMarque,
  marqueCourante,
} from '@/services/marque';

export function useMarque(): ContexteDeMarque {
  return useSyncExternalStore(
    abonnerALaMarque,
    marqueCourante,
    () => MARQUE_MAISON,
  );
}
